import React from 'react';
import {
  Button,
  Dropdown,
  Form,
  Grid,
  Input,
  Message,
} from 'semantic-ui-react';
import DatePicker from 'components/DatePicker';
import PropTypes from 'prop-types';
import { endOfDay, format } from 'date-fns';
import { isNotBlank } from 'utils/stringUtils';
import autoBind from 'auto-bind';

const formatFilterDateMessage = date =>
  date ? format(date, 'dd MMM yyyy') : null;

export class ActionBar extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { ...props.filters };
  }

  onKybStatusChanged(e, { value }) {
    this.setState({
      kybStatus: value,
    });
  }

  onApplyFilterButtonClicked() {
    const { onApplyFilter } = this.props;
    const {
      startCreatedDate,
      endCreatedDate,
      kybStatus,
      searchKeyword,
    } = this.state;
    onApplyFilter({
      startCreatedDate,
      endCreatedDate: endCreatedDate ? endOfDay(endCreatedDate) : null,
      kybStatus,
      searchKeyword,
      isKybRegistrationCompleted: true,
    });
  }

  onResetFilterButtonClicked() {
    this.setState(
      {
        startCreatedDate: null,
        endCreatedDate: null,
        kybStatus: 'all',
        searchKeyword: '',
      },
      this.onApplyFilterButtonClicked
    );
  }

  onSearchKeywordChanged(event, { value }) {
    this.setState({
      searchKeyword: value,
    });
  }

  onStartCreatedDateChanged(value) {
    this.setState({
      startCreatedDate: value,
    });
  }

  onEndCreatedDateChanged(value) {
    this.setState({
      endCreatedDate: value,
    });
  }

  renderCurrentFilterInfo() {
    const { filters } = this.props;

    return (
      <Message info>
        <p>
          Showing{' '}
          <strong>
            {
              filters.kybStatusOptions.find(s => s.value === filters.kybStatus)
                .text
            }
          </strong>{' '}
          businesses
          {(filters.startCreatedDate !== null ||
            filters.endCreatedDate !== null) && (
            <>
              {' '}
              created
              {filters.startCreatedDate !== null && (
                <>
                  {' '}
                  from{' '}
                  <strong>
                    {formatFilterDateMessage(filters.startCreatedDate)}
                  </strong>
                </>
              )}
              {filters.endCreatedDate !== null && (
                <>
                  {' '}
                  until{' '}
                  <strong>
                    {formatFilterDateMessage(filters.endCreatedDate)}
                  </strong>
                </>
              )}
            </>
          )}
          {isNotBlank(filters.searchKeyword) && (
            <>
              {' '}
              containing keyword <strong>{filters.searchKeyword}</strong>
            </>
          )}
        </p>
      </Message>
    );
  }

  render() {
    const {
      startCreatedDate,
      endCreatedDate,
      kybStatus,
      searchKeyword,
    } = this.state;
    const { filters, isLoading } = this.props;

    return (
      <>
        <Form>
          <Grid>
            <Grid.Column width={4}>
              <label htmlFor="start-created-date">Created date from</label>
              <DatePicker
                id="start-created-date"
                onChange={this.onStartCreatedDateChanged}
                selected={startCreatedDate}
                isClearable
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <label htmlFor="end-created-date">to</label>
              <DatePicker
                id="end-created-date"
                onChange={this.onEndCreatedDateChanged}
                selected={endCreatedDate}
                isClearable
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <label htmlFor="kyb-status">KYB Status</label>
              <Dropdown
                id="kyb-status"
                fluid
                selection
                options={filters.kybStatusOptions}
                value={kybStatus}
                onChange={this.onKybStatusChanged}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <label style={{ margin: '100%' }}>
                <span>&nbsp;</span>
              </label>
              <Button
                primary
                onClick={this.onApplyFilterButtonClicked}
                disabled={isLoading}
                loading={isLoading}
              >
                Apply Filter
              </Button>
              <Button
                primary
                basic
                onClick={this.onResetFilterButtonClicked}
                disabled={isLoading}
                loading={isLoading}
              >
                Reset Filter
              </Button>
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={12}>
              <Input
                placeholder="Search for business name, business owner, or email"
                icon="search"
                onChange={this.onSearchKeywordChanged}
                value={searchKeyword}
                fluid
              />
            </Grid.Column>
          </Grid>
        </Form>
        {this.renderCurrentFilterInfo()}
      </>
    );
  }
}

ActionBar.propTypes = {
  filters: PropTypes.shape({
    startCreatedDate: PropTypes.instanceOf(Date),
    endCreatedDate: PropTypes.instanceOf(Date),
    kybStatus: PropTypes.string.isRequired,
    searchKeyword: PropTypes.string,
    kybStatusOptions: PropTypes.array,
    isKybRegistrationCompleted: PropTypes.bool,
  }).isRequired,
  isLoading: PropTypes.bool,
  onApplyFilter: PropTypes.func.isRequired,
};

ActionBar.defaultProps = {
  isLoading: false,
};

export default ActionBar;
